import React from 'react'
import { ProductCardStock } from '../productsPanel/ProductCardStock'

export const ModalSell = ({venta}) => {
 
    const {estado, id, items, mpResponse,tramite,usuario, infoProduct} = venta

  return (
    <div className='_modal-form '>
        {infoProduct.map(item=>
            <div className="_productCardStock " key={item.id}>

                <ProductCardStock key={id+ "adm"} item={item}/>
            </div>
        )}

        {tramite}
    </div>
  )
}
